
import React, {ReactElement, FC} from "react";
import {Box, Typography, Button} from "@mui/material";
import "./styles/Home.css"
import StarfieldAnimation from 'react-starfield-animation'
import { useNavigate } from 'react-router-dom'
import ResumeDoc from '../data/CharlotteLimWeeTeng.pdf'
import { DownloadButton } from "../components/IconButtons/IconButtons";
 
const Home: FC<any> = (): ReactElement => {
    const navigate = useNavigate();
    const handleAboutMe = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        navigate('/about');
    }


    return (
        
        <Box sx={{
            flexGrow: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            opacity: 1
        }}
        className="home-container"
        >
            
            <StarfieldAnimation
                style={{
                position: 'absolute',
                width: '100%',
                height: '100%'
                }}
            />
            <div className="home-content-container">
                <Typography variant="h3">Charlotte Lim's Website</Typography>
                <div className="home-button-container">
                    <Button onClick={(e) => handleAboutMe(e)}>About Page</Button>
                    <div className="divider"/>
                    <a href={ResumeDoc} download="CharlotteLimWeeTeng" target='_blank' rel="noreferrer">
                    <DownloadButton text="Resume"/>
                    </a>
                </div>
            </div>
        </Box>
    );
};

export default Home;